import type { PortfolioEvaluationPlan } from "Infrastructure/ApiZfp/Schema/portfolioEvaluationPlan";
import { PortfolioEvaluationWarningItemQuestionnaireEvaluationType } from "Infrastructure/ApiZfp/Schema/portfolioEvaluationWarningItemQuestionnaireEvaluationType";

export const getRiskToleranceWarningItem = (evaluationPlan: PortfolioEvaluationPlan) =>
  (evaluationPlan.evaluationWarning?.instrumentWarningItems ?? []).find(
    (item) => item.questionnaireEvaluationType === PortfolioEvaluationWarningItemQuestionnaireEvaluationType.RiskToleranceType,
  );

export const formatSrriSri = (srri: number | null, sri: number | null): string => {
  if (!sri && !srri) return "—";

  const sriLabel = sri == null || sri === 0 ? "-" : String(sri);
  const srriLabel = srri == null || srri === 0 ? "-" : String(srri);
  return `${srriLabel}/${sriLabel}`;
};
